export const PRODUCT_ICON = [
  {
    productGroup: "Frescos",
    url: "/static/icons/Icons/icon-frescos.png",
  },
  {
    productGroup: "Congelados",
    url: "/static/icons/Icons/icon-congelados.png",
  },
  {
    productGroup: "Mercearia",
    url: "/static/icons/Icons/icon-mercearia.png",
  },
  {
    productGroup: "Laticínios, cremes vegetais e ovos",
    url: "/static/icons/Icons/icon-lacticinios.png",
  },
  {
    productGroup: "Bebidas",
    url: "/static/icons/Icons/icon-bebidas.png",
  },
  {
    productGroup: "Refeições prontas",
    url: "/static/icons/Icons/icon-refeicoesprontas.png",
  },
];
